<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Főoldal</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!--ion-card color="primary">
    <ion-card-header>
      <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Üdvözöljük a Sulinform felületén!</ion-card-title>
      <ion-card-subtitle>Válasszon a menük közül!</ion-card-subtitle>
    </ion-card-header>
  </ion-card-->

  <ion-card *ngIf="loginMode == 'dolgozo'">
    <ion-card-header>
      <ion-card-title>Könyvelt cég választás</ion-card-title>
    </ion-card-header>
<ion-card-content style="margin:0 !important;padding: 0 !important;">
  <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="feljegyzesek">
    <ng-container *ngFor="let f of feljegyzesek">
    <ion-item *ngIf="f.INAKTIV != '1'" [button]="true" detail="false"  (click)="openFeljegyzes(f)">
      <ion-icon color="primary" slot="start" [name]="f.icon || 'briefcase'" size="large"></ion-icon>
      <ion-label>
        <strong>{{f.NEV}}</strong><br />
        <ion-note color="" class="ion-text-wrap">
          {{f.ADOSZAM}}
        </ion-note><br />
        <ion-note color="" class="ion-text-wrap">
          {{f.UGYVEZETO || "-"}}<br>
          <i>{{f.EMAIL || "-"}}</i>
        </ion-note>
      </ion-label>
      <div class="metadata-end-wrapper" slot="end">
        <img src="assets/icon/ugyfelkapu.png" height="32px" [style]="'vertical-align: middle;margin-right:5px;'+(f.UGYFF ? 'filter: grayscale(0);':'filter: grayscale(1);')">
        <img src="assets/icon/nav.svg" height="32px" [style]="'vertical-align: middle;margin-right:5px;'+(f.OSAUSER ? 'filter: grayscale(0);':'filter: grayscale(1);')">
        <span [style]="'vertical-align: middle;margin-right:5px;'+(f.NAVM2M ? 'color:var(--ion-color-success);':'color:gray;')">M2M</span>
        <ion-icon style="vertical-align: middle;" size="large" *ngIf="f.nk > 0" [color]="f.k == f.nk ? 'success':'danger'" name="card"></ion-icon>
        <ion-icon style="vertical-align: middle;" size="large" *ngIf="!(f.nk > 0)" name="card"></ion-icon>
        <ion-icon style="vertical-align: middle;" size="large" color="medium" name="chevron-forward"></ion-icon>
      </div>
    </ion-item>
      
    </ng-container>
  </ion-list>
</ion-card-content>

  </ion-card>
  
  <ion-modal class="" style="z-index: 1000" #feljegyzesmodal >
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="close()">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Feljegyzés</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto"> 
        {{f.tantargy_nev}} - {{f.targynap}} - {{f.dvez}} {{f.dker}}<br>
        {{f.szoveg || f.tema || f.ertekeles || "-"}}<br>
          <i>{{f.tvez}} {{f.tker}} {{f.db=='ertekeles' && f.tipus !="-" ? "- "+f.tipus : ""}}</i>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
